module.exports = __webpack_public_path__ + "img/return.8c0bfb69.svg";